import React, { useState, useEffect, useRef } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./dropstyle.css";

const RatingDropDown = ({ options, selectedItems, onChange, buttonLabel }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleDropdown = () => {
    if (!dropdownOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      const shouldOpenAbove = spaceBelow < 200 && spaceAbove > 200;

      setDropdownStyle({
        position: "fixed", // Ensure it's at the top level
        top: shouldOpenAbove ? `${rect.top - 220}px` : `${rect.bottom}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        zIndex: 9999, // Stay above everything
      });
    }
    setDropdownOpen((prev) => !prev);
  };

  const handleCheckboxChange = (value) => {
    const updatedSelection = {
      ...selectedItems,
      [value]: !selectedItems[value],
    };
    onChange(updatedSelection);
  };

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isSelected = Object.values(selectedItems).includes(true);

  return (
    <div ref={buttonRef} style={{ position: "relative", width: "120px" }}>
      {/* Dropdown Button */}
      <button
        onClick={toggleDropdown}
        className={`dropnewBtn ${isSelected ? "selected" : ""}`}
      >
        <p
          style={{
            fontSize: "1rem",
            margin: 0,
            color: isSelected ? "var(--primary-color)" : "var(--text-color)",
          }}
        >
          {buttonLabel}
        </p>

        {dropdownOpen ? (
          <KeyboardArrowUpIcon
            style={{
              color: isSelected ? "var(--primary-color)" : "var(--text-color)",
            }}
          />
        ) : (
          <KeyboardArrowDownIcon
            style={{
              color: isSelected ? "var(--primary-color)" : "var(--text-color)",
            }}
          />
        )}
      </button>

      {/* Dropdown Content */}
      {dropdownOpen && (
        <div
          ref={dropdownRef}
          className="bxShadowdrp"
          style={{
            ...dropdownStyle,
            backgroundColor: "#fff",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            maxHeight: "200px",
            overflowY: "auto",
            borderRadius: "12px",
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
                cursor: "pointer",
                fontSize: "1rem",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!selectedItems[option.value]}
                    onChange={() => handleCheckboxChange(option.value)}
                    color="primary"
                  />
                }
                label={option.label}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RatingDropDown;
